import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { ec2Get, ec2Post, ec2Delete } from '../utils/ec2api';

const PLATAFORMAS = [
  { id: 'instagram', label: '📸 Instagram', color: '#E1306C' },
  { id: 'facebook', label: '📘 Facebook', color: '#1877F2' },
  { id: 'tiktok', label: '🎵 TikTok', color: '#000' },
  { id: 'whatsapp', label: '💬 WhatsApp', color: '#25D366' },
];

export default function CampanaExterna() {
  const [campanas, setCampanas] = useState([]);
  const [titulo, setTitulo] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [hashtags, setHashtags] = useState('#MonkeyPhone #eSIM #Conectado');
  const [plataforma, setPlataforma] = useState('instagram');
  const [costo, setCosto] = useState('');
  const [file, setFile] = useState(null);
  const [linkDestino, setLinkDestino] = useState('https://monkeyphone.net/Consulta');
  const [subiendo, setSubiendo] = useState(false);
  const [copiadoId, setCopiadoId] = useState(null);

  useEffect(() => { loadCampanas(); }, []);

  const loadCampanas = async () => {
    try { setCampanas(await ec2Get('/campanas')); } catch (e) { console.error(e); }
  };

  const copiarTexto = (c) => {
    const text = `${c.titulo}\n\n${c.descripcion}\n\n🔗 ${c.link || ''}\n\n${c.hashtags}`;
    navigator.clipboard.writeText(text);
    setCopiadoId(c.id);
    toast.success('Texto copiado al portapapeles');
    setTimeout(() => setCopiadoId(null), 2000);
  };

  const abrirPlataforma = (plat) => {
    const urls = {
      instagram: 'https://www.instagram.com/',
      facebook: 'https://www.facebook.com/',
      tiktok: 'https://www.tiktok.com/upload',
      whatsapp: 'https://web.whatsapp.com/',
    };
    window.open(urls[plat] || urls.instagram, '_blank');
  };

  const publicarInstagram = async (c) => {
    if (!c.media_url) { toast.warn('Esta campaña no tiene imagen/video'); return; }
    toast.info('Publicando en Instagram...', { autoClose: 3000 });
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const brandTags = '#MonkeyPhone #eSIM #eSIMInternacional #MonkeyMovil #DatosMoviles #ViajaConectado';
      const caption = `${c.titulo}\n\n${c.descripcion}\n\n👆 Link en la bio para comprar\n\n${c.hashtags}\n${brandTags}`;
      // Usar URL pública de S3 (sin presigned params)
      const publicUrl = c.media_key ? `https://monkeyphone-promos.s3.amazonaws.com/${c.media_key}` : c.media_url;
      const payload = c.media_type === 'video'
        ? { video_url: publicUrl, caption, media_type: 'REELS' }
        : { image_url: publicUrl, caption };

      const res = await fetch(`${apiUrl}/prod/instagram_publish`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      const body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body || data;

      if (body.ok) {
        toast.success('✅ Publicado en Instagram');
      } else {
        const fbError = body.detail?.error?.message || body.detail?.detail?.error?.message || '';
        const msg = fbError ? `${body.error}: ${fbError}` : (body.error || 'Error al publicar');
        toast.error(msg, { autoClose: 8000 });
        console.error('IG error:', body);
      }
    } catch (err) {
      console.error('Error:', err);
      toast.error('Error de conexión');
    }
  };

  const publicarFacebook = async (c) => {
    if (!c.media_url && !c.link) { toast.warn('Esta campaña no tiene imagen ni link'); return; }
    toast.info('Publicando en Facebook...', { autoClose: 3000 });
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const message = `${c.titulo}\n\n${c.descripcion}\n\n${c.hashtags}`;
      const publicUrl = c.media_key ? `https://monkeyphone-promos.s3.amazonaws.com/${c.media_key}` : '';
      const payload = {
        message,
        image_url: publicUrl || '',
        link: c.link || '',
      };
      const res = await fetch(`${apiUrl}/prod/facebook_publish`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      const body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body || data;
      if (body.ok) {
        toast.success('✅ Publicado en Facebook');
      } else {
        const fbError = body.detail?.error?.message || '';
        toast.error(fbError ? `Error: ${fbError}` : 'Error al publicar en Facebook', { autoClose: 8000 });
        console.error('FB error:', body);
      }
    } catch (err) {
      console.error('Error:', err);
      toast.error('Error de conexión');
    }
  };

  const crear = async () => {
    if (!titulo || !descripcion) { toast.warn('Escribe título y descripción'); return; }
    setSubiendo(true);
    try {
      let media_key = '';
      let media_type = 'image';

      if (file) {
        const isVideo = file.type.startsWith('video');
        media_type = isVideo ? 'video' : 'image';
        const uploadData = await ec2Post('/upload_url', { filename: file.name, content_type: file.type });
        await fetch(uploadData.upload_url, { method: 'PUT', headers: { 'Content-Type': file.type }, body: file });
        media_key = uploadData.key;
      }

      await ec2Post('/campanas', {
        titulo, descripcion, hashtags, media_key, media_type,
        plataforma, costo_estimado: parseFloat(costo) || 0, estatus: 'publicado',
        link: linkDestino,
      });

      toast.success('Campaña creada');
      setTitulo(''); setDescripcion(''); setCosto(''); setFile(null);
      loadCampanas();
    } catch (e) {
      console.error(e);
      toast.error('Error al crear campaña');
    } finally { setSubiendo(false); }
  };

  const eliminar = async (id) => {
    try {
      await ec2Delete('/campanas', { id });
      toast.success('Campaña eliminada');
      loadCampanas();
    } catch { toast.error('Error'); }
  };

  const totalCosto = campanas.reduce((s, c) => s + (parseFloat(c.costo_estimado) || 0), 0);

  const inputStyle = { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ccc', marginBottom: '10px', boxSizing: 'border-box' };

  return (
    <div style={{ marginTop: '20px' }}>
      <h2>📱 Campañas Redes Sociales</h2>

      {/* Resumen de costos */}
      {campanas.length > 0 && (
        <div style={{ background: '#e8f0fe', borderRadius: '14px', padding: '16px', marginBottom: '20px', textAlign: 'center' }}>
          <div style={{ fontSize: '12px', color: '#4b5563' }}>Inversión total en campañas</div>
          <div style={{ fontSize: '28px', fontWeight: '800', color: '#1b2938' }}>${totalCosto.toLocaleString()} MXN</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>{campanas.length} campañas creadas</div>
        </div>
      )}

      {/* Crear campaña */}
      <div style={{ background: '#fff', borderRadius: '16px', padding: '20px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: '20px' }}>
        <h3 style={{ margin: '0 0 14px 0', fontSize: '16px', color: '#1b2938' }}>Nueva campaña</h3>
        <input placeholder="Título del post" value={titulo} onChange={(e) => setTitulo(e.target.value)} style={inputStyle} />
        <textarea placeholder="Texto del post..." value={descripcion} onChange={(e) => setDescripcion(e.target.value)} rows={3} style={inputStyle} />
        <input placeholder="#hashtags separados por espacio" value={hashtags} onChange={(e) => setHashtags(e.target.value)} style={inputStyle} />

        <select value={linkDestino} onChange={(e) => setLinkDestino(e.target.value)} style={inputStyle}>
          <option value="https://monkeyphone.net/Consulta">🛒 Recarga y Consulta</option>
          <option value="https://monkeyphone.net/Ofertas">🔥 Ofertas</option>
          <option value="https://monkeyphone.net/Esim">📱 Compra eSIM Monkey</option>
          <option value="https://monkeyphone.net/Ofertasinternacional">🌐 eSIM Internacional</option>
          <option value="https://monkeyphone.net/Referidos">🎁 Invita a un amigo</option>
          <option value="https://monkeyphone.net/Promos">🎬 Promociones</option>
          <option value="https://monkeyphone.net">🌐 Página oficial</option>
        </select>

        <div style={{ display: 'flex', gap: '8px', marginBottom: '10px', flexWrap: 'wrap' }}>
          {PLATAFORMAS.map(p => (
            <button key={p.id} onClick={() => setPlataforma(p.id)} style={{
              padding: '8px 14px', borderRadius: '10px', border: plataforma === p.id ? `2px solid ${p.color}` : '1px solid #e2e8f0',
              background: plataforma === p.id ? p.color + '15' : '#fff', cursor: 'pointer', fontSize: '13px', fontWeight: '600',
            }}>
              {p.label}
            </button>
          ))}
        </div>

        <input type="number" placeholder="Costo estimado (MXN)" value={costo} onChange={(e) => setCosto(e.target.value)} style={inputStyle} />
        <label style={{ display: 'block', marginBottom: '10px', fontSize: '14px', color: '#4b5563' }}>
          Imagen o Video:
          <input type="file" accept="image/*,video/*" onChange={(e) => setFile(e.target.files[0])} style={{ ...inputStyle, marginTop: '4px' }} />
        </label>
        <button onClick={crear} disabled={subiendo} className="orange-button" style={{ width: '100%' }}>
          {subiendo ? '⏳ Creando...' : '📤 Crear Campaña'}
        </button>
      </div>

      {/* Lista de campañas */}
      {campanas.map((c) => (
        <div key={c.id} style={{ background: '#fff', borderRadius: '16px', overflow: 'hidden', marginBottom: '14px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
          {c.media_url && (
            c.media_type === 'video'
              ? <video src={c.media_url} style={{ width: '100%', maxHeight: 250, objectFit: 'cover' }} controls muted />
              : <img src={c.media_url} alt="" style={{ width: '100%', maxHeight: 250, objectFit: 'cover' }} />
          )}
          <div style={{ padding: '14px 16px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
              <span style={{ fontWeight: '700', fontSize: '15px', color: '#1b2938' }}>{c.titulo}</span>
              <span style={{ fontSize: '11px', padding: '3px 10px', borderRadius: '20px', background: '#e8f0fe', color: '#1b2938', fontWeight: '600' }}>
                {PLATAFORMAS.find(p => p.id === c.plataforma)?.label || c.plataforma}
              </span>
            </div>
            <p style={{ fontSize: '13px', color: '#4b5563', margin: '0 0 6px 0', whiteSpace: 'pre-wrap' }}>{c.descripcion}</p>
            <p style={{ fontSize: '12px', color: '#0056b3', margin: '0 0 10px 0' }}>{c.hashtags}</p>
            {c.costo_estimado > 0 && (
              <div style={{ fontSize: '13px', color: '#92400e', marginBottom: '10px' }}>💰 ${parseFloat(c.costo_estimado).toLocaleString()} MXN</div>
            )}
            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={() => copiarTexto(c)} style={{
                flex: 1, padding: '8px', borderRadius: '10px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: '600',
                background: copiadoId === c.id ? '#dcfce7' : '#f0f4f8', color: copiadoId === c.id ? '#166534' : '#1b2938',
              }}>
                {copiadoId === c.id ? '✅ Copiado' : '📋 Copiar texto'}
              </button>
              <button onClick={() => {
                if (c.plataforma === 'instagram') publicarInstagram(c);
                else if (c.plataforma === 'facebook') publicarFacebook(c);
                else abrirPlataforma(c.plataforma);
              }} style={{
                flex: 1, padding: '8px', borderRadius: '10px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: '600',
                background: '#1b2938', color: '#fff',
              }}>
                🚀 Publicar
              </button>
              <button onClick={() => eliminar(c.id)} style={{
                padding: '8px 12px', borderRadius: '10px', border: 'none', cursor: 'pointer',
                background: '#fef2f2', color: '#ef4444', fontSize: '13px',
              }}>
                ✕
              </button>
            </div>
            <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '8px' }}>{new Date(c.created_at).toLocaleString()}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
